export type DesignerCurrentPlanButtonState =
  | "current"
  | "reactivate"
  | "purchase";

const addMonths = (sourceDate: Date, monthCount: number): Date => {
  const result = new Date(sourceDate);
  result.setMonth(result.getMonth() + monthCount);
  return result;
};

export const calculateAnnualTermEndDateFromStartDate = (
  termStartDate: Date | null
): Date | null => {
  if (!termStartDate || Number.isNaN(termStartDate.getTime())) {
    return null;
  }

  return addMonths(termStartDate, 12);
};

export const countRemainingMonthlyCyclesInAnnualTerm = (input: {
  termStartDate: Date | null;
  termEndDate?: Date | null;
  referenceDate?: Date;
}): number => {
  const termStartDate = input.termStartDate;
  const termEndDate =
    input.termEndDate ?? calculateAnnualTermEndDateFromStartDate(termStartDate);
  const referenceDate = input.referenceDate ?? new Date();

  if (
    !termStartDate ||
    !termEndDate ||
    Number.isNaN(termStartDate.getTime()) ||
    Number.isNaN(termEndDate.getTime()) ||
    termEndDate.getTime() <= referenceDate.getTime()
  ) {
    return 0;
  }

  let cycleStart = new Date(termStartDate);
  let cycleEnd = addMonths(cycleStart, 1);
  let remainingCycles = 0;
  let guard = 0;

  while (cycleStart < termEndDate && guard < 240) {
    if (cycleEnd.getTime() > referenceDate.getTime()) {
      remainingCycles += 1;
    }

    cycleStart = new Date(cycleEnd);
    cycleEnd = addMonths(cycleEnd, 1);
    guard += 1;
  }

  return remainingCycles;
};

export const resolveDesignerCurrentPlanButtonState = (input: {
  hasCancelledState: boolean;
  hasRemainingPrepaidTerm: boolean;
  hasExpiredMembership: boolean;
}): DesignerCurrentPlanButtonState => {
  if (input.hasCancelledState) {
    return input.hasRemainingPrepaidTerm ? "reactivate" : "purchase";
  }

  if (input.hasExpiredMembership) {
    return "purchase";
  }

  return "current";
};
